import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { capabilities } from '@/mocks/smart-farm';

export default function Capabilities() {
  return (
    <section id="capabilities" className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-50 scroll-mt-20">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="核心能力"
          title="六大核心能力"
          subtitle="以统一数字底座连接田间、仓储、渠道与消费者，让农业经营从经验驱动走向数据驱动。"
        />

        <Reveal className="mt-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {capabilities.map((cap, idx) => {
              const highlighted = idx === 3;
              return (
                <div
                  key={cap.no}
                  className={`relative p-6 rounded-lg border transition-all duration-300 group hover:-translate-y-1 ${
                    highlighted
                      ? 'bg-foreground-950 border-foreground-950'
                      : 'bg-background-100 border-background-200 hover:border-accent-300'
                  }`}
                >
                  <span
                    className={`absolute top-5 right-5 text-xs font-medium tracking-wider ${
                      highlighted ? 'text-foreground-500' : 'text-foreground-400'
                    }`}
                  >
                    {cap.no}
                  </span>

                  <div
                    className={`w-12 h-12 flex items-center justify-center rounded-md ${
                      highlighted ? 'bg-accent-500 text-foreground-950' : 'bg-accent-100 text-accent-700'
                    }`}
                  >
                    <i className={`${cap.icon} text-2xl`}></i>
                  </div>

                  <h3
                    className={`mt-5 font-heading font-bold text-lg leading-snug ${
                      highlighted ? 'text-background-50' : 'text-foreground-950'
                    }`}
                  >
                    {cap.title}
                  </h3>
                  <p
                    className={`mt-3 text-sm leading-relaxed ${
                      highlighted ? 'text-foreground-300' : 'text-foreground-600'
                    }`}
                  >
                    {cap.desc}
                  </p>

                  <div className="mt-4 flex flex-wrap gap-1.5">
                    {cap.keywords.map((kw) => (
                      <span
                        key={kw}
                        className={`px-2.5 py-1 rounded-full text-xs whitespace-nowrap ${
                          highlighted
                            ? 'bg-background-50/10 text-background-100'
                            : 'bg-secondary-100 text-secondary-900'
                        }`}
                      >
                        {kw}
                      </span>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        </Reveal>
      </div>
    </section>
  );
}